import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'

import { fetchActivityReadableStats } from '../../../actions/activity'
import { postLoggingInfo } from '../../../actions/logging'
import { isViewingReadabilityScoresModal } from '../../../actions/modal'
import { fetchQuestReadableStats } from '../../../actions/quest'
import { getReadabilityScoresState } from '../../../utils/readability'
import { isNullOrEmpty } from '../../../utils'

export default class Indicator extends Component {
  constructor() {
    super()
    this.state = { hover: false }
    this.onUpdateScoresClickBound = this.onUpdateScoresClick.bind(this)
    this.onOpenReadabilityScoresClickBound =
      this.onOpenReadabilityScoresClick.bind(this)
    this.onIndicatorHoverBound = this.onIndicatorHover.bind(this)
    this.onIndicatorLeaveBound = this.onIndicatorLeave.bind(this)
  }

  render() {
    const { subsection, scores, readableStatsObject } = this.props
    const scoresState = getReadabilityScoresState(scores)
    const tooltipContent = this.getTooltipText(scores)
    const klass = isNullOrEmpty(readableStatsObject[subsection]) ? '' : 'active'

    return (
      <span className={`readability-indicator ${klass}`}>
        {scoresState === 'updating' && (
          <span
            className={`updating ${this.state.hover ? 'hover' : ''}`}
            onClick={this.onUpdateScoresClickBound}
            onMouseEnter={this.onIndicatorHoverBound}
            onMouseLeave={this.onIndicatorLeaveBound}
          >
            <span className="updating-icon" />
            <FormattedMessage
              id={'Readability.Indicator.Updating'}
              defaultMessage={'Update Scores'}
            />
          </span>
        )}

        {scoresState !== 'updating' && (
          <span
            className={`${scoresState} ${this.state.hover ? 'hover' : ''}`}
            data-for="averageGradeLevelTooltip"
            data-tip={tooltipContent}
            onMouseEnter={this.onIndicatorHoverBound}
            onMouseLeave={this.onIndicatorLeaveBound}
            onClick={this.onOpenReadabilityScoresClickBound}
          >
            <ReactTooltip
              id="averageGradeLevelTooltip"
              effect="solid"
              offset={{ right: 20, bottom: 15 }}
            />
            <span className="book-icon" />
            <span className="average-grade-level-score">
              {scoresState === 'has-average-grade-level'
                ? scores.stats.average_grade_level
                : '-'}
            </span>
          </span>
        )}
      </span>
    )
  }

  onUpdateScoresClick() {
    const { dispatch, quest, readableStatsObject, section } = this.props
    if (section === 'activity') {
      dispatch(fetchActivityReadableStats(quest.id, readableStatsObject.id))
    } else {
      dispatch(fetchQuestReadableStats(quest.id))
    }
  }

  onOpenReadabilityScoresClick() {
    const { quest, readableStatsObject, section, subsection, dispatch } =
      this.props

    let data = {
      readability: {
        source_page: section,
        source_field: subsection
      },
      quest: {
        id: quest.id,
        name: quest.name
      }
    }

    if (section === 'activity') {
      data.activity = {
        id: readableStatsObject.id,
        name: readableStatsObject.name
      }
    }

    dispatch(postLoggingInfo('readability_view', data))

    dispatch(isViewingReadabilityScoresModal(section, subsection))
  }

  getTooltipText(scores) {
    let retVal
    if (scores.stats.average_grade_level) {
      retVal = `Grade Level: ${scores.stats.average_grade_level}`
    } else {
      retVal = 'Grade level is not currently available'
    }

    return retVal
  }

  onIndicatorHover() {
    this.setState({ hover: true })
  }

  onIndicatorLeave() {
    this.setState({ hover: false })
  }
}

Indicator.propTypes = {
  quest: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  subsection: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  scores: PropTypes.object.isRequired,
  readableStatsObject: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/readability/Indicator.js